// ---------------------------------------------------------------------------
// The maintenance announcement.
//
// Split out of `AdminScreen.tsx`. On its own because it is the one control here
// that talks to every room at once and touches nobody in particular. The deploy
// workflow sends its own notice, so this form is for an update done by hand —
// see the deployment section of CLAUDE.md for why nothing predicts the cutover.
// ---------------------------------------------------------------------------

import { useState } from 'react';
import { Card, CardTitle } from '../../components/primitives/index.js';
import { ConfirmAction } from './atoms.js';

export function Maintenance({
  onAnnounce,
}: {
  onAnnounce: (message: string, delaySeconds: number) => void;
}) {
  const [message, setMessage] = useState('Countdown is updating. Rounds will pause briefly.');
  const [delaySeconds, setDelaySeconds] = useState(120);

  return (
    <Card>
      <CardTitle>Announce maintenance</CardTitle>
      <p className="mt-2 max-w-[520px] text-sm text-ink-muted text-pretty">
        Goes to every room at once. The deploy workflow sends its own, so this one
        is for an update you are doing by hand.
      </p>
      <div className="mt-3 flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-end">
        <label className="flex flex-1 flex-col gap-1.5">
          <span className="label-mono">message</span>
          <input
            value={message}
            onChange={(event) => setMessage(event.target.value)}
            className="min-h-11 w-full rounded-card border border-line bg-surface-2 px-3 text-[16px] text-ink"
          />
        </label>
        <label className="flex flex-col gap-1.5">
          <span className="label-mono">seconds until it lands</span>
          <input
            type="number"
            min={0}
            max={3600}
            value={delaySeconds}
            onChange={(event) => setDelaySeconds(Number(event.target.value))}
            className="tabular min-h-11 w-[120px] rounded-card border border-line bg-surface-2 px-3 font-mono text-[16px] text-ink"
          />
        </label>
        <ConfirmAction
          label="Announce"
          question={`Tell every room this, ${delaySeconds} seconds ahead?`}
          confirmLabel="Yes, announce it"
          onConfirm={() => onAnnounce(message.trim(), delaySeconds)}
        />
      </div>
    </Card>
  );
}
